export const pricelist = {
    methods: {
        pricelist(pdt_ids, pricing_hdr_id, type) {
            return this.$store.dispatch("general/pricelistrate", {
                pdt_ids: pdt_ids.join(","),
                pricing_hdr_id: pricing_hdr_id,
                sales_or_purchase_type: type
            }).then(result => {
                const {
                    data
                } = result
                return data
            })
        }
    }
}